import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GRID_SIZE } from '../../constants/gameConstants';
import { useGame } from '../../context/GameContext';

const PreviewContainer = styled(Box)(({ theme, size, color, image, isenemy }) => ({
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 10000,
  width: `${size}px`,
  height: `${size}px`,
  transform: 'translate(-50%, -50%)',
}));

const CoinPreview = styled(Box)(({ theme, size, color, image, isenemy }) => ({
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  backgroundColor: color || '#C0C0C0',
  backgroundImage: image ? `url(${image})` : 'none',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  border: `3px solid ${isenemy === 'true' ? '#8B0000' : '#2c3e50'}`,
  boxShadow: isenemy === 'true' 
    ? '0 0 15px 5px rgba(255, 0, 0, 0.4), 0 4px 15px rgba(0, 0, 0, 0.4)'
    : '0 4px 15px rgba(0, 0, 0, 0.4)',
  opacity: 0.9,
  transition: 'none',
}));

const TokenDragPreview = () => {
  const {
    tokenDragPreviewCoin: coin,
    tokenDragPreviewX: x,
    tokenDragPreviewY: y,
    tokenDragPreviewVisible: visible,
  } = useGame();
  if (!visible || !coin) return null;

  const coinSize = coin.isLarge ? GRID_SIZE * 2 : GRID_SIZE;

  return (
    <PreviewContainer
      sx={{
        left: x,
        top: y,
      }}
      size={coinSize}
    >
      <CoinPreview
        size={coinSize}
        color={coin.color}
        image={coin.image}
        isenemy={coin.isEnemy ? 'true' : 'false'}
      />
    </PreviewContainer>
  );
};

export default TokenDragPreview;
